/* AuditPolicyResultTree.js */

"use strict";
const treeify = require("treeify");
const _ = require("lodash");
const labelMap = {
    passed: {
        true: "(PASSED)",
        false: "(FAILED)",
    },
    operator: {
        must_contain: "Must Contain",
        must_contain_regex: "Must Contain Regex",
        must_only_contain: "Must Only Contain",
        must_only_contain_regex: "Must Only Contain Regex",
        must_contain_ordered: "Must Contain Ordered",
        must_contain_ordered_regex: "Must Contain Ordered Regex",
        must_only_contain_ordered: "Must Only Contain Ordered",
        must_only_contain_ordered_regex: "Must Only Contain Ordered Regex",
        must_not_contain: "Must Not Contain",
        must_not_contain_regex: "Must Not Contain Regex",
        must_not_contain_ordered: "Must Not Contain Ordered",
        must_not_contain_ordered_regex: "Must Not Contain Ordered Regex",
    },
    violations: {
        missing: "Missing",
        forbidden: "Forbidden",
        outOfOrder: "Out of Order",
        other: "Other",
    },
};

// const evalResult = {
//     condition: 'AND',
//     passed: true,
//     rules: [{
//         operator: 'must_contain',
//         value: [
//             'security authentication failure rate $[device.rate] log',
//             'security passwords min-length 6'
//         ],
//         result: {
//             passed: true
//         }
//     },
//     {
//         condition: 'OR',
//         passed: true,
//         rules: [{
//             operator: 'must_contain_ordered',
//             value: ['username bob', 'username bill'],
//             result: {
//                 passed: false,
//                 missing: [
//                     'username bob',
//                     'username bill'
//                 ]
//             }
//         },
//         {
//             operator: 'must_not_contain',
//             value: 'username cisco',
//             result: {
//                 passed: true
//             }
//         }
//         ]
//     }
//     ]
// };

class AuditPolicyResultTree {
    constructor(evalResult) {
        this.evalResult = _.cloneDeep(evalResult);
    }

    convert(resultObj, index) {
        let treeObj = {};
        const obj = resultObj || this.evalResult;
        // Group
        if (obj.hasOwnProperty("rules")) {
            const condition = _.get(obj, "condition", "AND");
            const passed = _.get(obj, "passed", "true");
            const rules = _.get(obj, "rules", []);

            if (rules.length > 0) {
                let newRules = {};
                rules.forEach((rule, index) => {
                    newRules = Object.assign(newRules, this.convert(rule, index));
                });
                _.set(treeObj, condition + " " + labelMap.passed[passed], newRules);
            }
        }

        // Rule
        else {
            const operator = _.get(obj, "operator", "");
            let value = _.get(obj, "value");

            if (!_.isArray(value)) {
                value = [value];
            }

            if (operator && value) {
                const passed = _.get(obj, ["result", "passed"], true);
                const newOperator =
                    index + ": " + labelMap.operator[operator] + " " + labelMap.passed[passed];

                _.set(treeObj, newOperator, {Rule: value});

                if (!passed) {
                    let violations = {};
                    Object.keys(labelMap.violations).forEach((violation) => {
                        if (_.get(obj, ["result", violation])) {
                            violations[labelMap.violations[violation]] = _.get(obj, [
                                "result",
                                violation,
                            ]);
                        }
                    });
                    _.set(treeObj, [newOperator, "Violations"], violations);
                }
            }
        }
        return treeObj;
    }

    getTreeHtml() {
        return treeify.asTree(this.convert(this.evalResult), true);
    }
}

module.exports = AuditPolicyResultTree;
